<app-table-header
  (reload)="loadData()"
  [loading]="isLoading()"
  [withExportOption]="false"
  >
  <div class="to-left d-flex align-items-center" style="gap: 10px;">
    <nz-range-picker
      [nzFormat]="dateFormat"
      [nzShowToday]="false"
      [(ngModel)]="selectedRange"
      (ngModelChange)="selectedMode = selectedRange.length > 0 ? 'custom' : 'thisYear'; loadData();"
      />

    <button
      nz-button
      [nzType]="selectedMode === 'yesterday' ? 'primary' : 'dashed'"
      (click)="selectedMode = 'yesterday'; loadData()"
      >
      Gestern
    </button>

    <button
      nz-button
      [nzType]="selectedMode === 'thisWeek' ? 'primary' : 'dashed'"
      (click)="selectedMode = 'thisWeek'; loadData()"
      >
      Diese Woche
    </button>

    <button
      nz-button
      [nzType]="selectedMode === 'thisMonth' ? 'primary' : 'dashed'"
      (click)="selectedMode = 'thisMonth'; loadData()"
      >
      Dieser Monat
    </button>

    <button
      nz-button
      [nzType]="selectedMode === 'thisYear' ? 'primary' : 'dashed'"
      (click)="selectedMode = 'thisYear'; loadData()"
      >
      Dieses Jahr
    </button>
  </div>
</app-table-header>

<nz-table appColumnLayout id="article-sales-history-table"
  #tableRef
  nzShowSizeChanger
  [nzData]="articleVariants"
  [nzLoading]="isLoading()"
  [nzFrontPagination]="false"
  [nzShowPagination]="false"
  >
  <thead>
    <tr>
      <th nzColumnKey="id" nzWidth="75px">#ID</th>
      <th nzColumnKey="name">Name</th>
      <th nzColumnKey="number">Nummer</th>
      <th nzColumnKey="ean">EAN</th>
      <th nzColumnKey="ek">EK</th>
      <th nzColumnKey="vk">VK</th>
      @if (!isNonPackable) {
        <th nzColumnKey="packaging">Verpackung</th>
      }
      <th nzColumnKey="margin">Gewinn</th>
      <th nzColumnKey="marginPercent">Marge %</th>
      @for (store of stores; track store) {
        <th [attr.nzColumnKey]="'store-' + store.id">{{ store.value }}</th>
      }
      <th nzColumnKey="totals"></th>
    </tr>
  </thead>
  <tbody>
    @for (variant of articleVariants; track variant) {
      <tr>
        <td>{{ variant.id }}</td>
        <td>{{ variant.name }}</td>
        <td>{{ variant.orderNumber }}</td>
        <td>{{ variant.ean }}</td>
        <td>
          @if (sheetFor(variant.id)?.ek == null) {
            nicht gepflegt
          } @else {
            {{ sheetFor(variant.id)?.ek | number:'1.2-2' }}&nbsp;€
          }
        </td>
        <td>
          @if (sheetFor(variant.id)?.vkGross == null) {
            nicht gepflegt
          } @else {
            <span nz-tooltip [nzTooltipTitle]="vatTooltip(sheetFor(variant.id))">
              {{ sheetFor(variant.id)?.vkGross | number:'1.2-2' }}&nbsp;€
            </span>
          }
        </td>
        @if (!isNonPackable) {
          <td>
            @if (sheetFor(variant.id)?.packaging == null) {
              nicht gepflegt
            } @else {
              {{ sheetFor(variant.id)?.packaging | number:'1.2-2' }}&nbsp;€
            }
          </td>
        }
        <td>
          @if (sheetFor(variant.id)?.margin == null) {
            nicht gepflegt
          } @else {
            {{ sheetFor(variant.id)?.margin | number:'1.2-2' }}&nbsp;€
          }
        </td>
        <td>
          @if (sheetFor(variant.id)?.marginPercent == null) {
            nicht gepflegt
          } @else {
            {{ sheetFor(variant.id)?.marginPercent | number:'1.1-1' }}&nbsp;%
          }
        </td>
        @for (store of stores; track store) {
          <td>
            <div
              [innerHTML]="(articleSalesHistory | articleVariantSaleHistoryItemByStore:+variant.id:+store.id) ?? '-'"
            ></div>
          </td>
        }
        <td>
          <div
            [innerHTML]="(articleSalesHistory | articleVariantSaleHistoryItemByStore:variant.id:null:'cols') ?? '-'"
          ></div>
        </td>
      </tr>
    }
    <tr>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      @if (!isNonPackable) {
        <td></td>
      }
      <td></td>
      <td></td>
      @for (store of stores; track store) {
        <td>
          <div
            [innerHTML]="articleSalesHistory | articleVariantSaleHistoryItemByStore:null:+store.id:'rows'"
          ></div>
        </td>
      }
      <td>
        {{ totalAmount | numberToCurrency }} / {{ totalCount | number }}
      </td>
    </tr>
  </tbody>
</nz-table>

<div style="padding-right: 16px; margin-top: 16px; display: flex; gap: 32px; justify-content: flex-end">
  <nz-statistic [nzValue]="((totalAmount ?? 0) | numberToCurrency)" nzTitle="Gesamtbetrag" />
  <nz-statistic [nzValue]="((totalCount ?? 0) | number)" nzTitle="Gesamtzahl" />
</div>
